import React, { useEffect, useState } from "react";
import "../Styles/Services.css";
import "../Styles/ContactSection.css";
import Footer from "./Footer";
import cncmilling from "../Images/cnc-milling.jpeg";
import cncturning from "../Images/cnc-turning.jpeg";
import manualturning from "../Images/manual-turning.jpeg";
import materialexpertise from "../Images/material-expertise.jpeg";
import prototypemachining from "../Images/prototype-machining.jpeg";
import largesmallbatch from "../Images/large-small-batch.jpg";
import outsourcedcapabilities from "../Images/outsourced_capabilities.jpg";
import qualitycontrol from "../Images/quality_control.jpg";

const services = [
  {
    img: cncturning, alt: "CNC Turning", title: "CNC TURNING",
    items: ["High-precision turning for cylindrical components", "Multi-axis turning for intricate geometries", "Broaching capabilities", "4.5\" Bore diameter"]
  },
  {
    img: cncmilling, alt: "CNC Milling", title: "CNC MILLING",
    items: ["Cutting-edge CNC technology for precise machining", "Multi-axis milling for high-tolerance components"]
  },
  {
    img: manualturning, alt: "Manual Turning", title: "MANUAL TURNING",
    items: ["Skilled operators for traditional turning processes", "Ideal for custom or low-volume projects or repairs", "6\" Bore Diameter"]
  },
  {
    img: prototypemachining, alt: "Prototype Machining", title: "PROTOTYPE MACHINING",
    items: ["Specialized in prototyping to bring concepts to life quickly", "Iterative milling for refining and optimizing prototypes"]
  },
  {
    img: largesmallbatch, alt: "Batch Production", title: "LARGE & SMALL BATCH PRODUCTION",
    items: ["Handle both large-scale and small-batch orders", "Efficient setup for cost-effective production"]
  },
  {
    img: materialexpertise, alt: "Material Expertise", title: "MATERIAL EXPERTISE",
    items: ["Aluminum, steel, titanium, and exotic alloys", "Customized tooling solutions for different materials"]
  },
  {
    img: qualitycontrol, alt: "Quality Control", title: "QUALITY CONTROL",
    items: ["In-process and post machining QC", "Multistage inspection reports", "CMM validation", "Post coating and finishing QC"]
  },
  {
    img: outsourcedcapabilities, alt: "Outsourced Capabilities", title: "OUTSOURCED CAPABILITIES",
    items: ["Laser cutting & etching", "Waterjet cutting", "Wire EDM Services", "3D Printing", "Anodizing and Broaching", "Chrome and Nickel plating", "Painting and powder coating", "Heat treat and nitriding"]
  },
];

function ContactSection() {
  return (
    <div className="contact-us">
      <div className="contact-us-inner">
        <div className="contact-us-left">
          <p className="contact-us-eyebrow">Get In Touch</p>
          <h2 className="contact-us-heading">Let's build something<br />precise together.</h2>
          <div className="contact-us-items">
            <div className="contact-us-item">
              <span className="contact-us-icon">📍</span>
              <div>
                <span className="contact-us-label">Address</span>
                <span className="contact-us-value">6240 Hawthorne Drive, Windsor, ON N8T 1J9, Canada</span>
              </div>
            </div>
            <div className="contact-us-item">
              <span className="contact-us-icon">📞</span>
              <div>
                <span className="contact-us-label">Phone</span>
                <span className="contact-us-value">+1 519 800-8080</span>
              </div>
            </div>
            <div className="contact-us-item">
              <span className="contact-us-icon">✉️</span>
              <div>
                <span className="contact-us-label">Email</span>
                <a href="mailto:info@precisionworks.ca" className="contact-us-value contact-us-link">info@precisionworks.ca</a>
              </div>
            </div>
          </div>
          <a href="/contact" className="contact-us-cta">Send Us a Message</a>
        </div>
        <div className="contact-us-map">
          <iframe
            title="Google Maps Locator"
            src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=6240+Hawthorne+Dr,+Windsor,+ON+N8T+1J9,+Canada&t=&z=16&ie=UTF8&iwloc=B&output=embed"
            style={{ width: "100%", height: "100%", border: 0, display: "block" }}
          ></iframe>
        </div>
      </div>
    </div>
  );
}

function Services() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setLoaded(true); }, []);

  return (
    <div className="services-page">
      <div className="page-hero">
        <h1>OUR SERVICES</h1>
        <div className="section-divider"></div>
        <p style={{ marginTop: 16 }}>
          From a basic idea all the way to production — we specialize in high precision design and machining,
          using industry-standard CAD-CAM software to precisely program your parts.
        </p>
      </div>

      <div className="services-grid-section" style={{ opacity: loaded ? 1 : 0, transition: "opacity 0.8s ease" }}>
        <div className="services-grid">
          {services.map((s) => (
            <div className="service-card" key={s.title}>
              <img src={s.img} alt={s.alt} />
              <div className="service-card-body">
                <h2>{s.title}</h2>
                <ul>{s.items.map((item, i) => <li key={i}>{item}</li>)}</ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <ContactSection />
      <Footer />
    </div>
  );
}

export default Services;
